module.exports = __webpack_public_path__ + "static/media/HCMM336.84a5d959.jpg";